import { LoadScreen } from './LoadScreen.js';
import { TutorialScene } from './TutorialScene.js';
import { ChooseHeroScene } from './ChooseHeroineScene.js';
import { BootLogic } from './BootLogic.js';
import { SinglePlayerScene } from './SinglePlayerScene.js';
import { TwoPlayerScene } from './MultiPlayerScene.js';
import { GameOverScene } from './GameOverScene.js';

var config = {
    type: Phaser.AUTO,
    width: 800,
    height: 600,
	zoom: 1,
	parent: 'gameContainer',
	background: 0x000,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 300 },
            debug: false
        }
    },
    scene: [
        LoadScreen,
        class BootScene extends Phaser.Scene {
            constructor() {super({ key: 'Boot', active: true })}
            preload = () => BootLogic.preloadGame(this.load)
            create = () => BootLogic.onStartBootScene(this.scene)
        },
        TutorialScene,
        ChooseHeroScene,
        SinglePlayerScene,
        TwoPlayerScene,
        GameOverScene
    ]
};

new Phaser.Game(config);
